import { createRouter, createWebHistory } from 'vue-router'
import Home from '../components/pages/Home.vue'
import Pricing from '../components/pages/Pricing.vue'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: Home,
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: Pricing,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
